export function parseLookupMetadata(item) {
  if (!item) return {};
  const raw = item.metadata;
  if (!raw) return {};
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }
  return raw;
}

/** Field rules from csadmin_lookups metadata (admin-configurable). */
export function getDocumentTypeRules(lookupItem) {
  const meta = parseLookupMetadata(lookupItem);
  return {
    requiresExpiry: !!(meta.requires_expiry ?? meta.requiresExpiry),
    requiresIssueDate: !!(meta.requires_issue_date ?? meta.requiresIssueDate),
    requiresDocumentNumber: !!(meta.requires_document_number ?? meta.requiresDocumentNumber),
  };
}

export function findLookupItem(items, code, label) {
  if (!items?.length) return null;
  const normalizedCode = String(code || '').trim().toLowerCase();
  if (normalizedCode) {
    const match = items.find((i) => String(i.code).trim().toLowerCase() === normalizedCode);
    if (match) return match;
  }
  const normalizedLabel = String(label || '').trim().toLowerCase();
  if (normalizedLabel) {
    return items.find((i) => String(i.label).trim().toLowerCase() === normalizedLabel)
      || items.find((i) => String(i.label).trim().toLowerCase().includes(normalizedLabel));
  }
  return null;
}

export function validateDocumentDates({ issueDate, expiryDate, rules }) {
  if (rules.requiresIssueDate && !issueDate) {
    return 'Please select the issue date';
  }
  if (rules.requiresExpiry && !expiryDate) {
    return 'Please select the expiry date for this document type';
  }
  if (issueDate && expiryDate && new Date(expiryDate) <= new Date(issueDate)) {
    return 'Expiry date must be after issue date';
  }
  return null;
}
